import React from 'react';
import TaxonomyTermThemeTeaser from './Teaser';
import TaxonomyTermThemeTeaserLarge from './TeaserLarge';
import Full from './Full';

const TaxonomyTermTheme = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'teaser':
      return (<TaxonomyTermThemeTeaser entity={entity} />);
    case 'teaser_large':
      return (<TaxonomyTermThemeTeaserLarge entity={entity} />);
    case 'full':
    default:
      return (<Full entity={entity} />);
  }
};

export default TaxonomyTermTheme;
